"use strict";
// TODO: Move all this to the shared lib whenever it's available.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteMode = void 0;
var DeleteMode;
(function (DeleteMode) {
    DeleteMode["Soft"] = "soft";
    DeleteMode["Hard"] = "hard";
    DeleteMode["None"] = "none";
    /**
     * @deprecated use 'soft' instead.
     */
    DeleteMode["InStatus"] = "in-status";
})(DeleteMode || (exports.DeleteMode = DeleteMode = {}));
//# sourceMappingURL=schema-properties-interface.js.map